import { on, select, getHeight, hasClass } from 'modules/dom'
import debounce from 'lodash.debounce'
import Velocity from 'velocity-animate'

const ANIMATION_DURATION = 250
const SHORT_ANIMATION_DURATION = 100
const ANIMATION_TYPE = 'swing'

const  CartPost = (el, contentPos = 0) => {
  const imageEl = select('.js-velo-image', el)
  const sponsorTextEl = select('.js-velo-sponsor', el)
  const contentEl = select('.js-velo-content', el)
  const moreLinkEl = select('.js-velo-link', el)
  const metaEl = select('.js-velo-meta', el)
  const isPaidContent = hasClass('js-card-paid', el)
  let contentAnimationPos = contentPos
  let metaAnimationPos = '-30px'

  const calculatePositions = () => {
    const imageHeight = getHeight(imageEl)
    const offset = sponsorTextEl ? getHeight(sponsorTextEl) : 0
    contentAnimationPos = Math.abs(imageHeight - offset) * -1

    if (isPaidContent) {
      contentAnimationPos -= 3
    }
  }

  const moveBack = { translateY: 0 }
  const visible = { opacity: 1 }
  const hidden = { opacity: 0 }

  on('load', calculatePositions, window)
  on('resize', debounce(calculatePositions, 150), window)

  on('mouseenter', () => {
    Velocity(contentEl, { translateY: contentAnimationPos }, ANIMATION_DURATION, ANIMATION_TYPE)
    Velocity(metaEl, { translateY: metaAnimationPos }, SHORT_ANIMATION_DURATION, ANIMATION_TYPE)
    Velocity(moreLinkEl, visible, ANIMATION_DURATION)
  }, el)

  on('mouseleave', () => {
    Velocity(contentEl, moveBack, ANIMATION_DURATION, ANIMATION_TYPE)
    Velocity(metaEl, moveBack, SHORT_ANIMATION_DURATION, ANIMATION_TYPE)
    Velocity(moreLinkEl, hidden, ANIMATION_DURATION)
  }, el)
}

export default CartPost
